module.exports = __webpack_public_path__ + "img/collar button diameter.f973b8d6.png";